export function requestNotificationPermissions(then)
{
    if (typeof window.Notification !== "function") {
        then(NotificationPermissionStatus.UNSUPPORTED)
    } else {
        Notification.requestPermission(status => {
            if (status === "granted") {
                then(NotificationPermissionStatus.ALLOWED)
            } else {
                then(NotificationPermissionStatus.BLOCKED)
            }
        });
    }
}

export const NotificationPermissionStatus = {
    PENDING: "PENDING",
    ALLOWED: "ALLOWED",
    BLOCKED: "BLOCKED",
    UNSUPPORTED: "UNSUPPORTED",
}